/**
 *
 * Mixin
 *
 */

import { mapState } from 'vuex';

import { VideoMixin } from '../Video';
import { NoteContainerMixin } from './NoteContainer';
import { QaContainerMixin } from './QaContainer';

export const PlayerNoteQaContainerMixin = {
  mixins: [VideoMixin, NoteContainerMixin, QaContainerMixin],

  data() {
    return {
      //player: null,
      startTime: 0,
      //
      origQuillTimeTagSeekVideo: null,
    };
  },

  computed: {
    ...mapState({
      userInfo: 'userInfo',
      ms_isDebug: 'isDebug',
    }),

    defaultSpeed() {
      return this.userInfo && this.userInfo.defaultSpeed;
    },
  },

  methods: {
    //
    changeSpeed() {
      //
    },

    timeTagSeekVideo(objTime) {
      const { time, speed } = objTime;
      this.startTime = Number(time);
      if (this.defaultSpeed == speed) {
        this.$options.player.j2s_seekVideo(this.startTime);
      } else {
        this.changeSpeed(Number(speed), this.startTime);
      }
      this.$options.player.j2s_resumeVideo();
    },

    //
    toPause() {
      //
    },

    ///
    handleQaOpened(isQaOpened) {
      if (isQaOpened) {
        this.toPause();
      }
    },
  },

  mounted() {
    this.origQuillTimeTagSeekVideo = window.quillTimeTagSeekVideo;
    window.quillTimeTagSeekVideo = (objTime) => {
      this.timeTagSeekVideo(objTime);
    };
  },

  beforeDestroy() {
    window.quillTimeTagSeekVideo = this.origQuillTimeTagSeekVideo;
  },
};
